import { api } from "./api";
import type {
  DocumentManagementDataType,
  PaginatedResponse,
} from "types/DataTypes";

type GetDocumentManagementFilesArgs = {
  filters?: Record<string, unknown>;
};

type GetDocumentManagementFileByIdArgs = {
  documentManagementFileId: string | number;
};

type PatchDocumentManagementFileArgs = {
  documentManagementFileId: string | number;
  data: Partial<DocumentManagementDataType>;
};

type GenerateAIDocumentAnalysisArgs = {
  documentManagementFileId: string | number;
  data: unknown;
};

export const documentManagementAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getDocumentManagementFiles: build.query<
      PaginatedResponse<DocumentManagementDataType>,
      GetDocumentManagementFilesArgs
    >({
      query: ({ filters = {} }) => ({
        url: `api/v1/document-management`,
        method: "GET",
        params: {
          ...(filters && { ...filters }),
        },
      }),
      providesTags: ["DocumentManagementFiles"],
    }),
    getDocumentManagementFileById: build.query<
      DocumentManagementDataType,
      GetDocumentManagementFileByIdArgs
    >({
      query: ({ documentManagementFileId }) => ({
        url: `api/v1/document-management/${documentManagementFileId}/`,
        method: "GET",
      }),
      providesTags: [
        "DocumentManagementFiles",
        "DocumentManagementFileValidation",
      ],
    }),
    patchDocumentManagementFileById: build.mutation<
      DocumentManagementDataType,
      PatchDocumentManagementFileArgs
    >({
      query: ({ documentManagementFileId, data }) => ({
        url: `api/v1/document-management/${documentManagementFileId}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "DocumentManagementFiles",
        "DocumentManagementFileValidation",
      ],
    }),
    generateAIDocumentAnalysis: build.mutation<
      unknown,
      GenerateAIDocumentAnalysisArgs
    >({
      query: ({ documentManagementFileId, data }) => ({
        url: `api/v1/document-management/${documentManagementFileId}/generate-allocator-notes/`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDocumentManagementFilesQuery,
  useGetDocumentManagementFileByIdQuery,
  usePatchDocumentManagementFileByIdMutation,
  useGenerateAIDocumentAnalysisMutation,
} = documentManagementAPI;
